// УНИВЕРСАЛЬНАЯ ФУНКЦИЯ ОЧИСТКИ ПОЛЕЙ ФОРМЫ
export default function clearFormFields(form) {
    if (!form) return;

    try {
        // Очищаем все поля
        const fields = form.querySelectorAll(".field");

        fields.forEach(field => {
            field.value = "";

            // Убираем состояние ошибки с родительского элемента
            const fieldParent = field.parentNode;
            if (fieldParent) {
                fieldParent.classList.remove("error");
            }

            // Очищаем сообщения об ошибках
            const errorElement = field.nextElementSibling;
            if (errorElement && errorElement.classList.contains("field-error")) {
                errorElement.textContent = "";
            }
        });

        // Убираем состояние загрузки с формы
        form.classList.remove("loading");

        // Восстанавливаем кнопку отправки
        const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
        if (submitButton) {
            submitButton.disabled = false;
            if (submitButton.dataset.originalText) {
                submitButton.textContent = submitButton.dataset.originalText;
                delete submitButton.dataset.originalText;
            }
        }

        // Скрываем статус формы
        const statusElement = form.querySelector(".form-status");
        if (statusElement) {
            statusElement.style.display = "none";
            statusElement.textContent = "";
            statusElement.className = "form-status"; // Убираем классы success/error
        }
    } catch (error) {
        console.error("Ошибка при очистке полей формы:", error);
    }
}

// ДОПОЛНИТЕЛЬНАЯ ФУНКЦИЯ: очистка всех форм в контейнере
export function clearAllFormsInContainer(container) {
    if (!container) return;

    const forms = container.querySelectorAll(".form");
    forms.forEach(form => clearFormFields(form));
}

// ДОПОЛНИТЕЛЬНАЯ ФУНКЦИЯ: очистка форм по селектору
export function clearFormsBySelector(selector) {
    const forms = document.querySelectorAll(selector);
    forms.forEach(form => clearFormFields(form));
}
